import * as T_T from 'cryface';
import { cloneDeep } from 'lodash';

export function hybridShareCommunityTongueOptions(vs: any) {
    const sum = T_T.sum(vs.Data.map((v: any) => (Number(v['Value']))));
    let data: any = vs.Data.map((v: any) => ({
        name: `${v['Key']}: (${Number(v['Value'])})`,
        value: Number(v['Value']),
        title: `${v['Key']}`,
        share: Math.round(Number(v['Value']) / sum * 10000) / 100
    })).sort((a: any, b: any) => b.value - a.value);
    const otherDataGotten = data.filter((v: any) => {
        return data.indexOf(v) >= 5;
    });
    const toDemoData = data.filter((v: any) => {
        return data.indexOf(v) < 5;
    });
    const otherValue = T_T.sum(otherDataGotten.map((d: any) => (d.value)));
    const other = {
        name: `Other: (${otherValue})`,
        value: otherValue,
        title: `Other`,
        share: Math.round(Number(otherValue / sum * 10000)) / 100,
    };
    data = [...toDemoData, other];
    const preLegend = data.map((v: any) => (`${v.name}`));
    const legend = preLegend;
    const max = cloneDeep(data).sort((a: any, b: any) => b.value - a.value);
    const first = max[0].title !== 'Other' ? max[0] : max[1];
    const sec = max[1].title !== 'Other' ? max[1] : max[2];
    const options = {
        rifoStory: {
            title: `<div>${first['title']} (${first['value']})</div><div>${sec['title']} (${sec['value']})</div>`,
            value: `${Math.round(first['share'] + sec['share'])}%`
        },
        first: first,
        sec: sec,
        legend: {
            // orient: 'vertical',
            x: 'left',
            data: legend,
        },
        max: max,
        series: [
            {
                name: 'age',
                type: 'pie',
                radius: ['60%', '70%'],
                center: ['50%', '47%'],
                data: data,
                label: {
                    normal: {
                        formatter: '{d}%',
                        // formatter: '{b}\r\n({d}%)',
                        position: 'inside',
                        show: false,
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                itemStyle: {
                    emphasis: {
                        // shadowBlur: 10,
                        // shadowOffsetX: 0,
                        // shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };
    return options;
}
